import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { MonoButton } from "../kits";


function ProjectManager() {
  const { slug } = useParams();
  const [courseId, setCourseId] = useState(null);
  const [projects, setProjects,] = useState([]);
  const [allCourses, setAllCourses] = useState([]);
  const [activeTab, setActiveTab] = useState("linked");
  const [allProjects, setAllProjects] = useState([]);
  


  // Projekt anlegen 
  const [newProject, setNewProject ] = useState ({
    title: "",
    problem: "",
    training: "",
    solution: "",
    mediaUrl: "",
    mediaType: "image",
    projectType: "",         // ➕ NEU
    durationDays: 0,         // ➕ NEU
    impact: ""               // ➕ NEU

  });


  // Projekt Edit
  const [editProject, setEditProject] = useState(null);

  // Project zuordnen mit ohne Kurs 
  const [unlinkedProjects, setUnlinkedProjects] = useState ([]);
  const [selectedProjectId, setSelectedProjectId] = useState(null);
 // fetch API Prject zuordnen 
useEffect(() => {
  fetch("https://www.denisbitter.de/stage01/api/get_all_projects.php")
    .then(res => res.json())
    .then(data => {
      if (data.success) setUnlinkedProjects(data.projects);
    });
}, []);

  // 1. Kurse laden
  useEffect(() => {
    fetch("https://www.denisbitter.de/stage01/api/get_all_courses.php")
      .then(res => res.json())
      .then(data => {
        if (data.success) setAllCourses(data.courses);
      });
  }, []);

  // . get all Projects 
  useEffect(() => {
  fetch("https://www.denisbitter.de/stage01/api/get_all_projects.php")
    .then(res => res.json())
    .then(data => {
      if (data.success) setAllProjects(data.projects);
    });
}, []);

  // 2. Slug → course_id → Projekte
  useEffect(() => {
    if (!slug) return;

    const loadCourseAndProjects = async () => {
      try {
        const courseRes = await fetch(`https://www.denisbitter.de/stage01/api/get_course_id_by_slug.php?slug=${slug}`);
        const courseData = await courseRes.json();
        if (courseData.success) {
          const id = parseInt(courseData.id);
          setCourseId(id);
          fetchProjects(id);
        } else {
          console.error("Kurs nicht gefunden");
        }
      } catch (err) {
        console.error("Fehler beim Laden des Kurses:", err);
      }
    };

    loadCourseAndProjects();
  }, [slug]);

  // 3. Projekte laden per ID
  const fetchProjects = async (id) => {
    try {
      const res = await fetch(`https://www.denisbitter.de/stage01/api/get_projects.php?course_id=${id}`);
      const data = await res.json();
      if (data.success) {
        setProjects(data.projects);
      } else {
        setProjects([]);
      }
    } catch (err) {
      console.error("❌ Fehler beim Projektabruf:", err);
    }
  };

  // 4. Dropdown-Klick
  const handleCourseChange = (e) => {
    const id = parseInt(e.target.value);
    setCourseId(id);
    setActiveTab("linked");
    fetchProjects(id);
  };

  // 8. Delete 
  
       const deleteProject = async (id) => {
        if (!window.confirm("Wirklich löschen?")) return;

        try {
          const res = await fetch("https://www.denisbitter.de/stage01/api/delete_project.php", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id }),
          });

          const result = await res.json();
          if (result.success) {
            alert("✅ Projekt gelöscht");
            fetchProjects(courseId);
          } else {
            alert("❌ Fehler beim Löschen");
          }
        } catch (err) {
          console.error("❌ Netzwerkfehler beim Löschen", err);
          alert("Fehler beim Löschen");
        }
      };

  return (
    <div className="space-y-6 py-10 font-mono bg-gray-950 max-w-full max-h-screen">
      <h2 className="text-sm font-bold text-center text-white">Projekt-Verwaltung</h2>

      <select
        className="border p-2 rounded w-full text-gray-900"
        value={courseId || ""}
        onChange={handleCourseChange}
      >
        <option value="">Kurs auswählen...</option>
        {allCourses.map(c => (
          <option key={c.id} value={c.id}>{c.title}</option>
        ))}
      </select>

      <div className="flex gap-4 text-xs font-mono  text-orange-50">



        <MonoButton onClick={() => setActiveTab("linked")} className={`pb-1 ${activeTab === "linked" ? "border-b-2 border-yellow-400" : ""}`}>
        Verknüpfte Projekte
        </MonoButton>
        <MonoButton onClick={() => setActiveTab("assign")} className={`pb-1 ${activeTab === "assign" ? "border-b-2 border-yellow-400" : ""}`}>
        Projekt zuordnen
        </MonoButton>
         <MonoButton onClick={() => setActiveTab("new")} className={`pb-1 ${activeTab === "new" ? "border-b-2 border-yellow-400" : ""}`}>
         Neues Projekt
          </MonoButton>
     
      <MonoButton>
         <Link
    to="/admindashboard"
    className="pb-1 hover:underline text-orange-50"
  >
    AdminDashboard
     </Link>
    </MonoButton>
 
      </div>

      {activeTab === "linked" && (
        <div>
     {projects.length > 0 ? (
  projects.map(p => (
    
    <div key={p.id} className="p-4 border rounded bg-white mb-2">
      <h4 className="font-bold">{p.title}</h4>
      <p>{p.problem}</p>
      <p className="text-xs text-gray-400">ID: {p.id}</p>

           {/* ⛔ Hier kommt der LöschMonoButton */}
    <MonoButton
      onClick={() => deleteProject(p.id)}
      className="mt-2 text-xs text-red-600 hover:underline"
    >
      🗑️ Löschen
    </MonoButton>

          <MonoButton
  onClick={() => setEditProject(p)}
  className="text-blue-600 text-xs mt-2"
>
  ✏️ Bearbeiten
          </MonoButton>
           <MonoButton
      onClick={async () => {
        if (!window.confirm("Projekt wirklich entkoppeln?")) return;

        const res = await fetch("https://www.denisbitter.de/stage01/api/unlink_project_from_course.php", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ project_id: p.id, course_id: courseId })
        });

        const result = await res.json();
        if (result.success) {
          setProjects(prev => prev.filter(proj => proj.id !== p.id));
        } else {
          alert("Fehler beim Entkoppeln");
        }
      }}
      className="text-xs text-red-500 underline mt-2"
    >
      🗑️ Projekt entkoppeln
    </MonoButton>

      

      
    </div>
  ))
) : (
  <p className="text-gray-500">Keine Projekte gefunden.</p>
)}

        </div>
      )}
{activeTab === "assign" && courseId && (
  <div className="border p-4 rounded bg-white space-y-2">
    <h3 className="font-bold text-xs">Bestehendes Projekt zuordnen</h3>

    <select
      className="border p-2 w-full rounded"
      value={selectedProjectId}
      onChange={(e) => setSelectedProjectId(parseInt(e.target.value))}
    >
      <option value="">Projekt auswählen...</option>
      {unlinkedProjects.map(p => (
        <option key={p.id} value={p.id}>{p.title} (ID: {p.id})</option>
      ))}
    </select>

    <MonoButton
      className="bg-orange-500 text-white px-4 py-1 rounded"
      onClick={async () => {
        if (!selectedProjectId) return;

        const res = await fetch("https://www.denisbitter.de/stage01/api/link_project_to_course.php", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ course_id: courseId, project_id: selectedProjectId }),
        });

        const result = await res.json();
        if (result.success) {
          alert("✅ Projekt erfolgreich zugeordnet");
          fetchProjects(courseId); // neu laden
        } else {
          alert("❌ Fehler bei Zuordnung");
        }
      }}
    >
      ➕ Zuordnen
    </MonoButton>
  </div>
)}

{activeTab === "new" && (
  <div className="border p-4 space-y-2 bg-gray-50 rounded">
    <h3 className="font-bold text-xs"><span className="text-orange-50 text-lg font-bold">+</span> Neues Projekt anlegen</h3>
    <input
  type="text"
  placeholder="Projekt Trainings Name (z. B. 3D, Web, Video)"
  value={newProject.projectType}
  onChange={e => setNewProject(p => ({ ...p, projectType: e.target.value }))}
  className="border p-2 rounded w-full text-xs"
/>

<input
  type="number"
  placeholder="Dauer in Tagen"
  value={newProject.durationDays}
  onChange={e => setNewProject(p => ({ ...p, durationDays: parseInt(e.target.value) }))}
  className="border p-2 rounded w-full text-xs"
/>

<input
  type="text"
  placeholder="was konnte mit dem Training für den kudnen für Vorteil sein "
  value={newProject.impact}
  onChange={e => setNewProject(p => ({ ...p, impact: e.target.value }))}
  className="border p-2 rounded w-full text-xs"
/>

    <input
      value={newProject.title}
      onChange={e => setNewProject(p => ({ ...p, title: e.target.value }))}
      className="border p-2 rounded w-full text-xs"
      placeholder="Titel"
    />
    <textarea
      value={newProject.problem}
      onChange={e => setNewProject(p => ({ ...p, problem: e.target.value }))}
      className="border p-2 rounded w-full text-xs"
      placeholder="Vor welchen Problem stand der Kunde "
       rows={3} //
    />
    <textarea
      value={newProject.training}
      onChange={e => setNewProject(p => ({ ...p, training: e.target.value }))}
      className="border p-2 rounded w-full text-xs"
      placeholder="Welches Training wurde absolviert - Modul Animation in After Effects"
       rows={6} //
    />
    <textarea
      value={newProject.solution}
      onChange={e => setNewProject(p => ({ ...p, solution: e.target.value }))}
      className="border p-2 rounded w-full text-xs"
      placeholder="wie wurde das Porblem gelöst kurze Beschreibung "
       rows={6} //
    />

    <select
      value={newProject.mediaType}
      onChange={e => setNewProject(p => ({ ...p, mediaType: e.target.value }))}
      className="border p-2 rounded w-full text-xs"
    >
      <option value="image">Bild</option>
      <option value="video">Video</option>
      <option value="youtube">YouTube</option>
    </select>

    <input
      type="text"
      value={newProject.mediaUrl}
      onChange={e => setNewProject(p => ({ ...p, mediaUrl: e.target.value }))}
      placeholder="Medien-URL (optional)"
      className="border p-2 rounded w-full text-xs"
    />

  <MonoButton
  onClick={async () => {
    const res = await fetch("https://www.denisbitter.de/stage01/api/add_project.php", {
      
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...newProject, course_id: courseId || null }),
    });

    let result;
    try {
      const text = await res.text(); // Serverantwort als Text holen
      result = JSON.parse(text);     // Dann versuchen, als JSON zu parsen
    } catch (err) {
      alert("⚠️ Serverantwort ist kein gültiges JSON");
      console.error("❌ Fehler beim Parsen", err);
      return;
    }

    if (result.success) {
      alert("✅ Projekt hinzugefügt");
      if (courseId) fetchProjects(courseId);
      setNewProject({
          title: "",
          problem: "",
          training: "",
          solution: "",
          mediaUrl: "",
          mediaType: "image",
          projectType: "",
          durationDays: "0",
          impact: ""
});
    } else {
      alert("❌ Fehler beim Speichern: " + (result.error ?? "Unbekannter Fehler"));
    }
  }}
  className= "py-1 px-4 w-full text-xs"
>
  Speichern
</MonoButton>

  </div>
)}



{editProject && (
  <div className="border p-4 space-y-2 bg-blue-50 rounded">
    <h3 className="font-bold text-xs">✏️ Projekt bearbeiten (ID {editProject.id})</h3>

    <input
      value={editProject.title}
      onChange={e => setEditProject(p => ({ ...p, title: e.target.value }))}
      className="border p-2 rounded w-full text-xs"
      placeholder="Titel"
    />

         <input
        type="number"
        placeholder="Dauer in Tagen" 
        value={editProject.durationDays || ""}
        onChange={e => setEditProject(p => ({ ...p, durationDays: parseInt(e.target.value) || 0 }))}
        className="border p-2 rounded w-full text-xs"
       
      />

    <textarea
      value={editProject.problem}
      onChange={e => setEditProject(p => ({ ...p, problem: e.target.value }))}
      className="border p-2 rounded w-full text-xs"
      placeholder="Problem"
       rows={3} //
    />
    <textarea
      value={editProject.training}
      onChange={e => setEditProject(p => ({ ...p, training: e.target.value }))}
      className="border p-2 rounded w-full text-xs"
      placeholder="Training"
       rows={6} //
    />
    <textarea
      value={editProject.solution}
      onChange={e => setEditProject(p => ({ ...p, solution: e.target.value }))}
      className="border p-2 rounded w-full text-xs"
      placeholder="Lösung"
       rows={6} // <-- Höhe
    />

    <select
      value={editProject.mediaType}
      onChange={e => setEditProject(p => ({ ...p, mediaType: e.target.value }))}
      className="border p-2 rounded w-full text-xs"
    >
      <option value="image">Bild</option>
      <option value="video">Video</option>
      <option value="youtube">YouTube</option>
    </select>

    <input
      type="text"
      value={editProject.mediaUrl}
      onChange={e => setEditProject(p => ({ ...p, mediaUrl: e.target.value }))}
      placeholder="Medien-URL"
      className="border p-2 rounded w-full text-xs"
    />

    <input
        type="text"
        placeholder="Projekttyp (z. B. 3D, Web, Video)"
        value={editProject.projectType || ""}
        onChange={e => setEditProject(p => ({ ...p, projectType: e.target.value }))}
        className="border p-2 rounded w-full text-xs"
      />

 

      <input
        type="text"
        placeholder="Erfolg / Wirkung"
        value={editProject.impact || ""}
        onChange={e => setEditProject(p => ({ ...p, impact: e.target.value }))}
        className="border p-2 rounded w-full text-xs"
      />





    <div className="flex gap-4">
      <MonoButton
        onClick={async () => {
          const res = await fetch("https://www.denisbitter.de/stage01/api/update_project.php", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(editProject),
          });

          const result = await res.json();
          if (result.success) {
            alert("✅ Gespeichert");
            setEditProject(null);
            if (courseId) fetchProjects(courseId);
          } else {
            alert("❌ Fehler beim Speichern");
          }
        }}
        className=" w-full px-4 py-1  text-xs"
      >
        Speichern
      </MonoButton>

      <MonoButton
        onClick={() => setEditProject(null)}
        className="w-full text-xs"
      >
        Abbrechen
      </MonoButton>
    </div>
  </div>
)}



    </div>
  );
  
}

export default ProjectManager;
